<template>
    <div>
        <div class="form-section-heading" v-if="showCourseTable">
            {{ trans('users.headline.course_info') }}
        </div>
        <section class="section" v-if="showCourseTable">
            <div class="course-info-table">
                <div class="label" v-if="userCourseAssignmentFormFields.courses && userCourseAssignmentFormFields.courses.length != 0">
                    {{ trans('users.headline.assigned_course') }}
                </div>

                <div v-if="userCourseAssignmentFormFields.courses && userCourseAssignmentFormFields.courses.length != 0">
                    <div class="course-info-table-heading">
                        <div class="course-info-table-heading__col">
                            {{trans('users.course-info-table.course_title')}}
                        </div>
                        <div class="course-info-table-heading__col">
                            {{trans('users.course-info-table.client_license')}}
                        </div>
                        <div class="course-info-table-heading__col">
                            {{trans('users.course-info-table.start_date')}}
                        </div>
                        <div class="course-info-table-heading__col">
                            {{trans('users.course-info-table.end_date')}}
                        </div>
                    </div>

                    <div class="course-info-table-body"
                        v-for="(course, index) in userCourseAssignmentFormFields.courses"
                        :key="'course' + index">
                        <div class="course-info-table-body__col course-info-table-body__main-content">
                            {{course.course ? course.course.label : ''}}
                        </div>
                        <div class="course-info-table-body__col">
                            {{course.client ? course.client.label : ''}}
                        </div>
                        <div class="course-info-table-body__col">
                            {{ formatDate(course.startDate) }}
                        </div>
                        <div class="course-info-table-body__col">
                            {{ formatDate(course.endDate) || '-'}}
                        </div>
                    </div>
                </div>


                <div v-if="showCoursesbyUserGroups" class="label">
                    {{ trans('users.headline.assigned_usergroup_course') }}
                </div>

                <div v-if="showCoursesbyUserGroups">
                    <div v-for="(ug, index) in userCourseAssignmentFormFields.userGroups" :key="'ug' + index">
                        <div v-if="Object.keys(ug).length !== 0 && ug.userGroup.courses && ug.userGroup.courses.length !== 0">
                            <div class="label">{{ug.userGroup.label}}:</div>

                            <div class="course-info-table-heading">
                                <div class="course-info-table-heading__col">
                                    {{trans('users.course-info-table.course_title')}}
                                </div>
                                <div class="course-info-table-heading__col">
                                    {{trans('users.course-info-table.client_license')}}
                                </div>
                                <div class="course-info-table-heading__col">
                                    {{trans('users.course-info-table.start_date')}}
                                </div>
                                <div class="course-info-table-heading__col">
                                    {{trans('users.course-info-table.end_date')}}
                                </div>
                            </div>

                            <div v-if="Object.keys(ug).length !== 0" >
                                <div class="course-info-table-body" v-for="(course, index) in ug.userGroup.courses" :key="'ugCourse' + index">
                                    <div class="course-info-table-body__col course-info-table-body__main-content">
                                        {{course ? course.title : ''}}
                                    </div>
                                    <div class="course-info-table-body__col">
                                        {{ug.client ? ug.client.label : ''}}
                                    </div>
                                    <div class="course-info-table-body__col">
                                        {{ formatDate(ug.startDate) }}
                                    </div>
                                    <div class="course-info-table-body__col">
                                        {{ formatDate(ug.endDate) || '-' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    var moment = require('moment');

    export default {
        props: [
            'userCourseAssignmentFormFields',
        ],

        computed: {
            showCourseTable() {
                return this.hasAssignedCourses || this.showCoursesbyUserGroups
            },

            showCoursesbyUserGroups() {
                return this.hasAssignedUserGroups && this.coursesExistInUserGroups;
            },

            hasAssignedCourses() {
                return this.userCourseAssignmentFormFields.courses && this.userCourseAssignmentFormFields.courses.length !== 0
            },

            hasAssignedUserGroups() {
                return this.userCourseAssignmentFormFields.userGroups && this.userCourseAssignmentFormFields.userGroups.length !== 0;
            },

            coursesExistInUserGroups() {
                var userGroups = this.userCourseAssignmentFormFields.userGroups;
                var courseExisted = false;
                if (userGroups) {
                    userGroups.forEach(ug => {
                        var temp = (ug.userGroup && ug.userGroup.courses.length == 0) ? false : true;
                        courseExisted = temp || courseExisted;
                    });
                }

                return courseExisted;
            }
        },

        methods: {
            formatDate(date) {
                return date ? moment(date).locale("'" + this.trans('users.course-info-table.local') + "'").format('DD.MM.YYYY'): null;
            },
        }
    }
</script>
